import React from 'react';
import Link from 'gatsby-link';
import { OutboundLink } from 'gatsby-plugin-google-analytics'

import '../../sass/components/_CTA.scss';

const CTA = (props) => (
  props.external ? 
    <OutboundLink rel="nofollow" className={`cta${props.light ? " light" : ""} ${props.className ? props.className : ""}`} href={props.to} target="_blank">{props.label}</OutboundLink>
  :
    <Link className={`cta${props.light ? " light" : ""} ${props.className && props.className}`} to={props.to}>{props.label}</Link>
);

export default CTA;



// WEBPACK FOOTER //
// ./src/components/CTA.js